import { axis, axisOp,size, startOp, endOp, axisOpIndex,normalizeShape,getAbsoluteShape } from './shape';
import {alea} from 'seedrandom';
import { cdf } from '@stdlib/stats-base-dists-beta';
import {createArrowElement,updateArrowElement} from './arrow';
// let scaleLevels;

const unitEdges = {
  Milliseconds: [0, 999],
  Seconds: [0, 59],
  Minutes: [0, 59],
  Hours: [0, 23],
  Days: [0, 31],
  Months: [0, 11],
};

const targetSizes = {
  small:1,
  medium:1.5,
  big:2
};

const unitWidth = {
  Milliseconds: 1,
  Seconds: 1000,
  Minutes: 1000 * 60,
  Hours: 1000 * 60 * 60,
  Days: 1000 * 60 * 60 * 24,
  Months: 1000 * 60 * 60 * 24 * 31,
  Years: 1000 * 60 * 60 * 24 * 31 * 12,
};

const unitWidthList = [
  [1, 'Milliseconds'],
  [1000, 'Seconds'],
  [1000 * 60, 'Minutes'],
  [1000 * 60 * 60, 'Hours'],
  [1000 * 60 * 60 * 24, 'Days'],
  [1000 * 60 * 60 * 24 * 31, 'Months'],
  [1000 * 60 * 60 * 24 * 31 * 12, 'Years'],
];

// const intervalDateMap = {
//   ms: 'Milliseconds',
//   msec: 'Milliseconds',
//   s: 'Seconds',
//   sec: 'Seconds',
//   m: 'Minutes',
//   min: 'Minutes',
//   mins: 'Minutes',
//   h: 'Hours',
//   hr: 'Hours',
//   hrs: 'Hours',
//   d: 'Date',
//   days: 'Date',
//   mth: 'Month',
//   mths: 'Month',
//   mo: 'Month',
//   mos: 'Month',
//   y: 'FullYear',
//   yr: 'FullYear',
//   yrs: 'FullYear',
// };

const unitsAbbr = {
  Milliseconds: 'ms',
  Seconds: 's',
  Minutes: 'm',
  Hours: 'h',
  Days: 'd',
  Months: 'mth',
  Years: 'yr',
};

// const intervalOrder = ['Milliseconds', 'Seconds', 'Minutes', 'Hours', 'Date', 'Month', 'FullYear'];

const unitScale = ['Milliseconds', 'Seconds', 'Minutes', 'Hours', 'Days', 'Months', 'Years'];

const unit2Date = {
  Milliseconds: 'Milliseconds',
  Seconds: 'Seconds',
  Minutes: 'Minutes',
  Hours: 'Hours',
  Days: 'Date',
  Months: 'Month',
  Years: 'FullYear',
};

function subInterval(value, interval) {
  value = new Date(value);
  value = value.getTime() % interval.interval;
  if (value < 0) {
    value += interval.interval;
  }

  value = interval.interval - value;

  return value / unitWidth[interval.subUnits[1]];

  //return (value * interval.interval) / (interval.subUnits[0] * unitWidth[interval.units[1]]);

  // const base = value[`get${unit2Date[interval]}`]();

  // return (
  //   unitEdges[interval][0] +
  //   unitEdges[interval][1] -
  //   base +
  //   (ceilInterval(value, interval).getTime() - value.getTime()) / unitWidth[interval]
  // );
  // return ceilInterval(value, interval).getTime() - value.getTime();
}

function floorInterval(value, interval) {
  if (_.isNumber(interval)) {
    if (!_.isNumber(value)) {
      value = new Date(value).getTime();
    }

    return new Date(Math.floor(value / interval) * interval);
  }

  value = new Date(value);
  if (interval == 'Milliseconds') {
    return value;
  }

  _.each(unitScale, (unit, i) => {
    if (!i) {
      return;
    }

    let floor = unit == 'Months' ? 1 : 0;

    value[`set${unit2Date[unitScale[i - 1]]}`](floor);
    if (unit == interval) {
      return false;
    }
  });

  return value;
}

function ceilInterval(value, interval) {
  if (_.isNumber(interval)) {
    if (!_.isNumber(value)) {
      value = new Date(value).getTime();
    }

    return new Date(Math.ceil(value / interval) * interval - 1);
  }

  value = floorInterval(value, interval);
  value[`set${unit2Date[interval]}`](value[`get${unit2Date[interval]}`]() + 1);
  value.setMilliseconds(-1);

  return value;
}

function middleInterval(value, interval) {
  let floor = floorInterval(value, interval);
  if (_.isNumber(interval)) {
    floor.setTime(floor.getTime() + interval / 2);

    return floor;
  }

  let ceil = new Date(floor);
  ceil[`set${unit2Date[interval]}`](ceil[`get${unit2Date[interval]}`]() + 1);
  ceil.setMilliseconds(-1);

  return (ceil.getTime() + floor.getTime()) / 2;
}

export default class Timeline {
  constructor(instance) {
    this.instance = instance;
    instance.on('preprocessoptions', (event, options) => this.onPreprocessOptions(options));
    instance.on('reload', () => this.updateIntervals());
    instance.on('ready', () => this.updateIntervals());
    instance.on('resize', () => this.updateIntervals());
    var me = this;
    const finalized = function() {
      me.updateIntervals();
      if(finalized.last) {
        clearTimeout(finalized.last);        
      }

      finalized.last = _.delay(()=>{
        finalized.last=null;
        me.updateIntervals();
      },10);
    };

    instance.chart.on('datazoom', finalized);
    instance.on('datazoom', finalized);
  }

  onPreprocessOptions(options) {
    // console.log('timeInterval:', options);
    if (options.chartType !== 'Timeline') {
      return;
    }

    this.timeInterval = axis.reduce((r, a) => {
      r[a] = {};
      return r;
    }, {});

    axis.forEach((a) => {
      let ax = `${a}Axis`;
      if (!Array.isArray(options[ax])) {
        options[ax] = [options[ax]];
      }

      this.timeInterval[a] = [];
      _.each(options[ax], (ax, i) => {
        if (ax.timeInterval) {
          // if (!scaleLevels) {
          //   const scale = _.find(this.instance.chart._componentsMap, ['__model.id', ax.id]).__model
          //     .axis.scale;
          //   scaleLevels = Object.getPrototypeOf(scale).constructor.scaleLevels;
          // }

          this.timeInterval[a][i] = _.defaults(
            {
              ...ax.timeInterval,
              id: ax.id,
            },
            {
              min: 'Seconds',
              max: 'Years',
              subInterval: false,
              localTimezone: true,
              subIntervalEdgeMultiplier: 1,
              roundTime: 'precise',
              roundPrecedence: 'precise',
            }
          );
        }
      });
    });

    _.each(options.series, (serie,seriesIndex) => {

      if(serie.type!=='scatter') {return;}

      const emphasisStyle = _.get(serie,'emphasis.lineStyle');
      axis.forEach((a, ai) => {
        const opi = ai?0:1
        const symbolSize = serie.symbolSize && serie.symbolSize[opi] || serie.symbolSize || 16;
        const interval = this.timeInterval[a][serie[`${a}AxisIndex`]];
        // if (!interval) {
        //   return;
        // }

        if (interval) {
          // let graph;
          if(!serie.isMinimap && serie.links && serie.links.length){
            if(!options.graphic){options.graphic={elements:[]};}

            
            serie.linkMap=serie.links.reduce((res,link, li)=>{
              if(!res[link.source]){
                res[link.source]=[];
              }

              res[link.source].push(link);

              if(!res[link.target]){
                res[link.target]=[];
              }

              res[link.target].push(link);
              link.graphicIndex = options.graphic.elements.length;
              link.id = 'link'+seriesIndex+'-'+li;
              const style = _.merge({
                  color:'#CCCCCC',
                  lineWidth:2,
                  targetMargin:2,
                },serie.lineStyle,link.lineStyle);
              link.normalStyle = style;
              link.currentStyle = style;
              const linkEmphasisStyle = _.get(link,'emphasis.lineStyle');
              
              if(emphasisStyle||linkEmphasisStyle){
                link.emphasisStyle = _.merge({},style,emphasisStyle,linkEmphasisStyle);                
              }
              
              // options.graphic.elements.push(
              // {
              //   type:'line',
              //   $action:'merge',
              //   id:link.id,
              //   shape:{
              //     x1:0,
              //     y1:0,
              //     x2:1,
              //     y2:1
              //   },
              //   style,
              //   left:0,
              //   top:0
              // });
              const graphic = {
                type:'group',
                children:[
                {
                  type:'bezierCurve',
                  id:link.id+'-line',
                  shape:{

                  },
                  style:{...style,
                    stroke: style.color,                    
                  },
                  z:2,
                  zlevel:2,
                  info:link,
                },
                {
                  type:'polygon',
                  id:link.id+'-target',
                  shape:{
                    points:[[0,0],[1,1],[1,0]],                                    
                  },
                  style:{...style,
                    fill: style.color,
                    lineWidth:0,
                    // lineWidth:1,
                    stroke:'#FFFFFF',
                    width:style.lineWidth
                  },
                  z:2,
                  zlevel:2,
                  info:link,
                },
                {
                  id:link.id+'-source',
                  type: style.sourceShape==='circle'?'circle':'polygon',
                  shape:{
                    points:[[0,0],[1,1],[1,0]],
                    cx:0,cy:0,r:1                                   
                  },
                  style:{...style,
                    fill: style.color,
                    lineWidth:0,
                    // lineWidth:1,
                    stroke:'#FFFFFF',
                    width:style.lineWidth
                  },
                  z:2,
                  zlevel:2,
                  info:link,
                }
                ],
                $action:'merge',
                // id:'target-'+link.id,
                id:link.id,
                z:2,
                zlevel:2,
                info:link,
                onmouseover: (params)=>{                  
                  const link = params.target.info;
                  if(link && link.emphasisStyle){
                    // console.log('onmouseover',link);
                    link.currentStyle=link.emphasisStyle;
                    this.instance.chart.setOption({ graphic:{ elements:[
                      {
                        id:link.id+'-line',
                        style:{...link.emphasisStyle,
                          stroke: link.emphasisStyle.color,                            
                        }
                      },
                      {
                        id:link.id+'-target',
                        style:{...link.emphasisStyle,
                          fill: link.emphasisStyle.color,
                          lineWidth:0,
                          width:link.emphasisStyle.lineWidth
                        }
                      },
                      {
                        id:link.id+'-source',
                        style:{...link.emphasisStyle,
                          fill: link.emphasisStyle.color,
                          lineWidth:0,
                          width:link.emphasisStyle.lineWidth
                        }
                      }
                     
                     ] } });
                    this.updateIntervals();
                  }
                },
                onmouseout: (params)=>{
                  const link = params.target.info;
                  if(link && link.emphasisStyle){
                    link.currentStyle=link.normalStyle;
                    this.instance.chart.setOption({ graphic:{ elements:[
                        {
                          id:link.id+'-line',
                          style:{...link.normalStyle,
                            stroke: link.normalStyle.color,                            
                          },
                        },
                        {
                          id:link.id+'-target',
                          style:{...link.normalStyle,
                            fill: link.normalStyle.color,
                            lineWidth:0,
                            width:link.normalStyle.lineWidth
                          },
                        },
                        {
                          id:link.id+'-source',
                          style:{...link.normalStyle,
                            fill: link.normalStyle.color,
                            lineWidth:0,
                            width:link.normalStyle.lineWidth
                          },
                        }
                      ]
                    }});
                    this.updateIntervals();
                  }
                },

                // left:0,
                // top:0,
                // originY:style.lineWidth
              };

              if(serie.linkTriggers){
                _.each(serie.linkTriggers,(trigger,name)=>{
                  if(graphic[`on${name}`]){
                    var oldTrigger = graphic[`on${name}`];
                  }

                  graphic[`on${name}`] = (params) => {
                    if(oldTrigger) {oldTrigger(params);}

                    trigger(params);
                  };
                });
              }

              options.graphic.elements.push(graphic);

              return res;
            },{})
          }

          serie.data.forEach((element, i) => {
            if (element.start !== undefined) {
              let start = element.start;
              start = new Date(start);
              // if (interval && !interval.localTimezone) {
              //   start.setMinutes(start.getMinutes() + start.getTimezoneOffset());
              // }

              element[`${a}Coordinate`] = start.getTime();
              element.value[ai] = element[`${a}Coordinate`];
              if(element.end !== undefined && element.periodTo === undefined && element.periodFrom === undefined){
                const {showStartSymbol,showEndSymbol} = _.merge({showStartSymbol:true,showEndSymbol:true},serie,element);
                

                const periodElement = {...element, itemStyle:{...element.itemStyle}};
                const end = new Date(element.end).getTime();
                periodElement.length = end-start.getTime();
                // periodElement.start = end;
                periodElement[`${a}Coordinate`] = end-periodElement.length/2;
                periodElement.value[ai] = periodElement[`${a}Coordinate`];
                periodElement.symbol = 'rect';
                periodElement.symbolHeight = periodElement.symbolSize && periodElement.symbolSize[opi] || periodElement.symbolSize || symbolSize;
                periodElement.symbolSize=[periodElement.symbolHeight,periodElement.symbolHeight];
                periodElement.periodFrom = serie.data.length;
                element.periodTo=i;
                serie.data[i]=periodElement;
                serie.data.push(element);
                const endElement = {...element, itemStyle:{...element.itemStyle}};
                
                _.set(element, 'label.show', false);
                _.set(endElement, 'label.show', false);              
                if(!_.get(periodElement, 'label.position')){
                  _.set(periodElement, 'label.position', 'insideLeft');                  
                }
                

                endElement.periodFrom = periodElement.periodFrom;
                endElement[`${a}Coordinate`] = end;
                if(!showEndSymbol) {
                  _.set(endElement, 'itemStyle.opacity',0);
                }

                serie.data.push(endElement);
                if(!showStartSymbol){
                  _.set(element, 'itemStyle.opacity',0);
                }
              }
            }

            if (interval.minTime === undefined || element[`${a}Coordinate`] < interval.minTime) {
              interval.minTime = element[`${a}Coordinate`];
            }

            if (interval.maxTime === undefined || element[`${a}Coordinate`] > interval.maxTime) {
              interval.maxTime = element[`${a}Coordinate`];
            }

            if(serie.linkMap && serie.linkMap[element.name]){
              
              serie.linkMap[element.name].forEach((link)=>{
                if(link.source===element.name)
                  {link.sourceItemIndex = i;}
                else
                  {link.targetItemIndex = i;}
              });
              // element.x=0;
              // element.y=0;

            }
          });
          // if(graph){
          //   graph.data = Object.values(graph.data);            
          // }

        }
      });
    });
    //this.updatePeriods(options);
    this.updateIntervals(options);
  }
  
  updateIntervals(options) {
    // console.log('updateIntervals');
    
    var me = this;
    let init = true;
    let patch = { series: [], graphic:{elements:[]} };
    if (!options) {
      options = this.instance.chart.getOption();
      if(!options) {return;}

      init = false;
    }

    if (options.chartType !== 'Timeline') {
      return;
    }

    // console.log(options.graphic.elements.map(el => el.children.map(ch => ch.style.color)));

    // console.log(JSON.stringify(options,null,2));

    let updated;
    _.each(options.series, (series, i) => {

      if (!init) {
        patch.series[i] = {};
      }

      let gridShape;
      if(series.type==='scatter') {
        axis.forEach((a, ai) => {
          const opi = ai?0:1
          //const symbolSize = series.periodElement.symbolSize && series.symbolSize[opi] || series.symbolSize || 16;
          
          const timeInterval = this.timeInterval[a][series[`${a}AxisIndex`]];

          if (timeInterval && !_.isEmpty(this.instance.chart._componentsMap)) {
            updated=true;
            const scale = _.find(this.instance.chart._componentsMap, ['__model.id', timeInterval.id])
              .__model.axis.scale;

            let windowStart = scale._extent[0];
            let windowEnd = scale._extent[1];
            let windowWidth = windowEnd - windowStart;

            let originalAxis = this.instance.options[`${a}Axis`];
            if (_.isArray(originalAxis)) {
              originalAxis = originalAxis[series[`${a}AxisIndex`]];
            }

            const grid = this.instance.options.grid[originalAxis.gridIndex||0];
            normalizeShape(grid);
            const chartRect = this.instance.getRect();

            gridShape = getAbsoluteShape(grid, chartRect);
            const gridSize = gridShape[size[a]];

            //this.instance.chart._componentsMap["_ec_\u0000series\u00000\u00000_xAxis.time"].__model.axis.scale
            // _extent
            // _interval
            // _extent
            //chart._componentsMap["_ec_xAxis-0_xAxis.time"].__model.id

            let currentUnits = _.findLast(unitWidthList, (iw) => iw[0] < windowWidth);
            currentUnits = currentUnits || unitWidthList[0];

            let currentInterval = {
              units: currentUnits,
              interval: scale._interval,
              window: [windowStart, windowEnd],
              offset: -windowStart % scale._interval,
            };
            let windowSizeChanged = true;
            if(timeInterval.current && windowWidth === timeInterval.current.window[1]-timeInterval.current.window[0]){
              windowSizeChanged=false;
            }

            if(windowSizeChanged){
              

              series.data.forEach((el, i) => {
                if(el.length){
                  el.symbolSize=[];
                  el.symbolSize[opi] = el.symbolHeight;
                  el.symbolSize[ai]=el.length*gridSize/windowWidth;
                  
                  // if(el.symbolSize[ai]<1){el.symbolSize[ai]=1;}

                  // if(el.symbolSize[ai]>1){console.log('sw: ',el.symbolSize[ai],el.length,gridSize,windowWidth);}
                }
              });
              if (!init) {
                patch.series[i].data = series.data;
              }
            }

            if (timeInterval.current && timeInterval.current.interval === currentInterval.interval) {
              return;
            }

            timeInterval.current = currentInterval;

            // let originalAxis = this.instance.options[`${a}Axis`];
            // if (_.isArray(originalAxis)) {
            //   originalAxis = originalAxis[series[`${a}AxisIndex`]];
            // }
            
            if (!init) {
              if (!patch[`${a}Axis`]) {
                patch[`${a}Axis`] = [];
              }
              
            } 

            if (
              timeInterval.precedenceValue == 'sub-interval' &&
              currentInterval.subUnits === undefined
            ) {
              currentInterval.subUnits = _.findLast(
                unitWidthList,
                (iw) => iw[0] < currentInterval.interval
              );
              currentInterval.subUnits = currentInterval.subUnits || unitWidthList[0];
              if (currentInterval.subUnits[1] == 'Years') {
                currentInterval.subUnits = _.findLast(unitWidthList, (iw) => iw[1] == 'Months');
              }
            }

            if (!init) {
              patch.series[i].data = series.data;
            }

            // console.log(currentInterval);
            // console.log('pre: ', new Date(windowStart - currentInterval.interval));
            // console.log('start: ', new Date(windowStart));
            // console.log('emd: ', new Date(windowStart + currentInterval.interval));
            // console.log('=====');

            const subCounter = {};
            let subMax = 0;
            series.data.forEach((el, i) => {            

              const coord = el[`${a}Coordinate`];

              if (
                (timeInterval.roundTime == 'precise' &&
                  (timeInterval.precedenceValue == 'evenly-distributed'||timeInterval.precedenceValue == 'randomly-distributed')) ||
                timeInterval.roundTime == 'floor'
              ) {
                el.units =
                  floorInterval(coord, currentInterval.interval).getTime() + currentInterval.offset;
              } else if (timeInterval.roundTime == 'middle') {
                el.units = middleInterval(coord, currentInterval.interval) + currentInterval.offset;
              } else if (timeInterval.roundTime == 'ceil') {
                el.units =
                  ceilInterval(coord, currentInterval.interval).getTime() + currentInterval.offset;
              }

              // console.log(i, el.name);
              // console.log('coord:', new Date(coord));
              // console.log('units:', new Date(el.units));
              // console.log('-----');
              el.value[ai] =
                timeInterval.roundTime !== 'precise' &&
                currentInterval.interval &&
                el.units !== undefined
                  ? el.units
                  : coord;

              if (timeInterval.precedenceValue == 'sub-interval') {
                let subCoord = coord;
                if (timeInterval.roundPrecedence == 'floor') {
                  subCoord = floorInterval(subCoord, currentInterval.subUnits[1]).getTime();
                } else if (timeInterval.roundPrecedence == 'middle') {
                  subCoord = middleInterval(subCoord, currentInterval.subUnits[1]);
                } else if (timeInterval.roundPrecedence == 'ceil') {
                  subCoord = ceilInterval(subCoord, currentInterval.subUnits[1]).getTime();
                }

                el.subUnits = subInterval(subCoord, currentInterval);

                el.value[axisOpIndex[a]] =
                  currentInterval.interval && el.subUnits !== undefined ? el.subUnits : 0;
              } else if ((timeInterval.precedenceValue == 'evenly-distributed'||timeInterval.precedenceValue == 'randomly-distributed')) {
                if (!subCounter[el.units]) {
                  subCounter[el.units] = 1;
                } else {
                  subCounter[el.units] += 1;
                }

                if (subMax < subCounter[el.units]) {
                  subMax = subCounter[el.units];
                }

                el.value[axisOpIndex[a]] = subCounter[el.units];
              }
            });
            if (timeInterval.precedenceValue == 'sub-interval') {
              if (!init) {
                if (!patch[`${axisOp[a]}Axis`]) {
                  patch[`${axisOp[a]}Axis`] = [];
                }

                patch[`${axisOp[a]}Axis`][series[`${axisOp[a]}AxisIndex`]] = getSubAxisPatch(
                  currentInterval
                );
              } else {
                let p = getSubAxisPatch(currentInterval);
                _.defaults(options[`${axisOp[a]}Axis`][series[`${axisOp[a]}AxisIndex`]], p);
                if (
                  p.axisLabel &&
                  p.axisLabel.formatter &&
                  options[`${axisOp[a]}Axis`][series[`${axisOp[a]}AxisIndex`]].axisLabel.formatter ===
                    undefined
                ) {
                  options[`${axisOp[a]}Axis`][series[`${axisOp[a]}AxisIndex`]].axisLabel.formatter =
                    p.axisLabel.formatter;
                }
              }
            } else if ((timeInterval.precedenceValue == 'evenly-distributed'||timeInterval.precedenceValue == 'randomly-distributed')) {
              var arng = new alea(me.instance.args.fullCid);
              timeInterval.precedenceValueDistribution = _.defaults(timeInterval.precedenceValueDistribution||{}, {
                max: 100,
                min: 0,
                deviation: 1,
                perCategory: []
              });            

              const distribution = timeInterval
              .precedenceValueDistribution
              .perCategory
              .reduce(function(res,cat){
                if(cat.itemCategory!==undefined){
                  res[cat.itemCategory] = _.defaults(cat, {
                    max: timeInterval.precedenceValueDistribution.max,
                    min: timeInterval.precedenceValueDistribution.min,
                    deviation: timeInterval.precedenceValueDistribution.deviation
                  });
                }

                return res;              
              }, {'':{
                max: timeInterval.precedenceValueDistribution.max,
                min: timeInterval.precedenceValueDistribution.min,
                deviation: timeInterval.precedenceValueDistribution.deviation
              }});
              
              
              series.data.forEach((el) => {
                if(el.periodFrom) {return;}

                const localMax = subCounter[el.units] + 1;
                const dist = distribution[el.itemCategory!==undefined?el.itemCategory:'']||distribution[''];
                if(dist.deviation<0.01){dist.deviation=0.01;}

                const catSubMax = subMax*(dist.max-dist.min)/100;
                const catOffset = subMax*dist.min/100;
                if(timeInterval.precedenceValue == 'evenly-distributed'){
                  el.value[axisOpIndex[a]] = catOffset + catSubMax - (el.value[axisOpIndex[a]] * catSubMax) / localMax;                
                }else{
                  el.value[axisOpIndex[a]] = catOffset + catSubMax*cdf(arng(),dist.deviation,dist.deviation,);
                }

                // el.value[axisOpIndex[a]] =
                //   subMax / (2 * localMax) + (el.value[axisOpIndex[a]] * subMax) / localMax;
              });

              series.data.forEach((el) => {
                if(el.periodFrom){
                  el.value[axisOpIndex[a]] = series.data[el.periodFrom].value[axisOpIndex[a]];
                }
              });

              let p = {
                type: 'value',
                min: 0,
                max: subMax,
                interval: 1,
                axisLabel: {
                  formatter: new Function('value', `
                    return (${subMax} - value)+'';
                    `)                
                },
              };
              if (!init) {
                if (!patch[`${axisOp[a]}Axis`]) {
                  patch[`${axisOp[a]}Axis`] = [];
                }

                patch[`${axisOp[a]}Axis`][series[`${axisOp[a]}AxisIndex`]] = p;
              } else {
                _.defaults(options[`${axisOp[a]}Axis`][series[`${axisOp[a]}AxisIndex`]], p);
                if (
                  options[`${axisOp[a]}Axis`][series[`${axisOp[a]}AxisIndex`]].axisLabel.formatter ===
                  undefined
                ) {
                  options[`${axisOp[a]}Axis`][series[`${axisOp[a]}AxisIndex`]].axisLabel.formatter =
                    p.axisLabel.formatter;
                }
              }
            }
          }

        });
        if(!init && !series.isMinimap && series.links){
          // if (!init) {
            let newElements = !init?patch.graphic.elements:[];
            let graphic = options.graphic;
            if (Array.isArray(graphic)) {
              graphic = graphic[0];
            }

            graphic = graphic.elements;
            if(init){newElements=graphic;}

            const viewStart = gridShape.top; 
            const viewEnd = viewStart + gridShape.height; 
            // console.log(viewStart,viewEnd);
            

            series.links.forEach((link)=>{
              const src = series.data[link.sourceItemIndex];
              const trg = series.data[link.targetItemIndex];
              if(!src || src.value[1]===undefined || !trg || trg.value[1]===undefined) {return;}

              const [x1,y1] = this.instance.chart.convertToPixel({seriesIndex:i}, [src.value[0],src.value[1]]);
              const [x2,y2] = this.instance.chart.convertToPixel({seriesIndex:i}, [trg.value[0],trg.value[1]]);

              const arrowGraphic = updateArrowElement(link,[x1,y1],[x2,y2],init&&graphic[link.graphicIndex],viewStart, viewEnd);
              

              if(init){
                newElements[link.graphicIndex] = arrowGraphic;                
              }else{
                newElements.push(...arrowGraphic);                
              }
            });            
          // }
        }
      }
      
    });
    
    
    // console.log('timeInterval:', JSON.stringify(options,null,2));
    if (!init) {
      for(let i=0;i<patch.graphic.elements.length;i++){
        if(!patch.graphic.elements[i])
        {
          patch.graphic.elements[i]={};
        }        

      }

    //   _.delay(()=>{
      this.instance.chart.setOption(patch);
    //   },200);
    }

  }
}

const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', ''];
days.reverse();

const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
months.reverse();

function getSubAxisPatch(currentInterval) {
  // let max = Math.round(currentInterval.interval / unitWidth[currentInterval.subUnits[1]]);
  let max = (currentInterval.interval / unitWidth[currentInterval.subUnits[1]]).toFixed(1);

  let patch = {
    type: 'value',
    //interval: 1,
    min: 0,
    max: max + 1,
    name: currentInterval.subUnits[1],
    axisLabel: {
      formatter: (value) =>
        value >= 0 && value <= max
          ? `+${(max - value).toFixed(1)}${unitsAbbr[currentInterval.subUnits[1]]}`
          : '',
    },
  };

  return patch;
}

//echarts/src/scale/Time.js
/*var scaleLevels = [
    // Format              interval
    ['hh:mm:ss', ONE_SECOND], // 1s
    ['hh:mm:ss', ONE_SECOND * 5], // 5s
    ['hh:mm:ss', ONE_SECOND * 10], // 10s
    ['hh:mm:ss', ONE_SECOND * 15], // 15s
    ['hh:mm:ss', ONE_SECOND * 30], // 30s
    ['hh:mm\nMM-dd', ONE_MINUTE], // 1m
    ['hh:mm\nMM-dd', ONE_MINUTE * 5], // 5m
    ['hh:mm\nMM-dd', ONE_MINUTE * 10], // 10m
    ['hh:mm\nMM-dd', ONE_MINUTE * 15], // 15m
    ['hh:mm\nMM-dd', ONE_MINUTE * 30], // 30m
    ['hh:mm\nMM-dd', ONE_HOUR], // 1h
    ['hh:mm\nMM-dd', ONE_HOUR * 2], // 2h
    ['hh:mm\nMM-dd', ONE_HOUR * 6], // 6h
    ['hh:mm\nMM-dd', ONE_HOUR * 12], // 12h
    ['MM-dd\nyyyy', ONE_DAY], // 1d
    ['MM-dd\nyyyy', ONE_DAY * 2], // 2d
    ['MM-dd\nyyyy', ONE_DAY * 3], // 3d
    ['MM-dd\nyyyy', ONE_DAY * 4], // 4d
    ['MM-dd\nyyyy', ONE_DAY * 5], // 5d
    ['MM-dd\nyyyy', ONE_DAY * 6], // 6d
    ['week', ONE_DAY * 7], // 7d
    ['MM-dd\nyyyy', ONE_DAY * 10], // 10d
    ['week', ONE_DAY * 14], // 2w
    ['week', ONE_DAY * 21], // 3w
    ['month', ONE_DAY * 31], // 1M
    ['week', ONE_DAY * 42], // 6w
    ['month', ONE_DAY * 62], // 2M
    ['week', ONE_DAY * 70], // 10w
    ['quarter', ONE_DAY * 95], // 3M
    ['month', ONE_DAY * 31 * 4], // 4M
    ['month', ONE_DAY * 31 * 5], // 5M
    ['half-year', (ONE_DAY * 380) / 2], // 6M
    ['month', ONE_DAY * 31 * 8], // 8M
    ['month', ONE_DAY * 31 * 10], // 10M
    ['year', ONE_DAY * 380] // 1Y
];*/

/*

[
  [
    "hh:mm:ss",
    1000
  ],
  [
    "hh:mm:ss",
    5000
  ],
  [
    "hh:mm:ss",
    10000
  ],
  [
    "hh:mm:ss",
    15000
  ],
  [
    "hh:mm:ss",
    30000
  ],
  [
    "hh:mm\nMM-dd",
    60000
  ],
  [
    "hh:mm\nMM-dd",
    300000
  ],
  [
    "hh:mm\nMM-dd",
    600000
  ],
  [
    "hh:mm\nMM-dd",
    900000
  ],
  [
    "hh:mm\nMM-dd",
    1800000
  ],
  [
    "hh:mm\nMM-dd",
    3600000
  ],
  [
    "hh:mm\nMM-dd",
    7200000
  ],
  [
    "hh:mm\nMM-dd",
    21600000
  ],
  [
    "hh:mm\nMM-dd",
    43200000
  ],
  [
    "MM-dd\nyyyy",
    86400000
  ],
  [
    "MM-dd\nyyyy",
    172800000
  ],
  [
    "MM-dd\nyyyy",
    259200000
  ],
  [
    "MM-dd\nyyyy",
    345600000
  ],
  [
    "MM-dd\nyyyy",
    432000000
  ],
  [
    "MM-dd\nyyyy",
    518400000
  ],
  [
    "week",
    604800000
  ],
  [
    "MM-dd\nyyyy",
    864000000
  ],
  [
    "week",
    1209600000
  ],
  [
    "week",
    1814400000
  ],
  [
    "month",
    2678400000
  ],
  [
    "week",
    3628800000
  ],
  [
    "month",
    5356800000
  ],
  [
    "week",
    6048000000
  ],
  [
    "quarter",
    8208000000
  ],
  [
    "month",
    10713600000
  ],
  [
    "month",
    13392000000
  ],
  [
    "half-year",
    16416000000
  ],
  [
    "month",
    21427200000
  ],
  [
    "month",
    26784000000
  ],
  [
    "year",
    32832000000
  ]
]

*/
